import React from "react";
import ReactDOM from "react-dom/client";
import { Capacitor } from "@capacitor/core";
import "@/index.css";
import App from "@/App";
import { hydrateAuthStorage } from "@/utils/authStorage";
import { initCapacitorNative } from "@/utils/capacitorNative";

if (typeof window !== "undefined" && Capacitor.isNativePlatform()) {
  window.__IS_MOBILE_APP__ = true;
}

(async () => {
  try {
    await hydrateAuthStorage();
  } catch (e) {
    console.warn("Auth storage hydrate failed", e);
  }

  try {
    await initCapacitorNative();
  } catch (e) {
    console.warn("Capacitor native init failed", e);
  }

  const root = ReactDOM.createRoot(document.getElementById("root"));
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
})();
